import "./AboutUs.module.css";
import Header from "@/reusable_sections/Header";
import OurStory from "./sections/OurStory";
import MissionAndValues from "./sections/MissionAndValues";
import OurTeam from "./sections/OurTeam";
import Footer from "@/reusable_sections/Footer";
export default function AboutUsPage() {
  return <div>
      <Header />
      <OurStory />
      <MissionAndValues />
      <OurTeam />
      <Footer />
    </div>;
}